import React, { createContext, useContext } from 'react';
import type { ModuleMountOptions } from '@opengov/psp-contract';

const PspContext = createContext<ModuleMountOptions | undefined>(undefined);

type Props = {
  pspOptions?: ModuleMountOptions;
  children: React.ReactNode;
};

export function PspProvider({ children, pspOptions }: Props) {
  return <PspContext.Provider value={pspOptions}>{children}</PspContext.Provider>;
}

export function usePspOptions(): ModuleMountOptions | undefined {
  const context = useContext(PspContext);
  return context;
}
